import './index.scss';
import 'components/select';

import './images/bg.png';

(function ($) {
  'use strict';

  const $context = $('.q-widget-meet');

  $('.q-select-input', $context).qselect('on', 'change', function (value, $el) {
    const options = $el.qselect('getOptions');
    const selectedOption = options.find((item) => item.value === value);

    const $ctaContainer = $('.q-cta-container', $context);
    const a = $('a', $ctaContainer);
    const checkoutUrl = a.attr('href');
    const offerParams = `?offer_ids%5B%5D=${value}`;

    $ctaContainer.addClass('active');
    $('.q-title', $ctaContainer).html(`Raio X completo ${selectedOption.text}`);
    a.attr('href', checkoutUrl.concat(offerParams));
  });

  $('.js-select-type', $context).on('click', function () {
    $('.js-select-type', $context).removeClass('active');
    $('.q-cta-container', $context).removeClass('active');
    $('.q-price-action', $context).hide();

    $(this).addClass('active');
    const { klass, price } = $(this).data();

    $('.q-cta-price', $context).text(`R$ ${price}`);
    $(klass).show();
  });
})(jQuery);
